/**
 * 项目全局常量定义
 */

/** 
 * 纹理尺寸常量 - 用于 UV 坐标计算和 Canvas 渲染
 * 
 * 这个值影响：
 * 1. Canvas 纹理的实际像素尺寸 (usePaintableTexture)
 * 2. UV 坐标与像素坐标的转换比例 (useStickerTextureDrag)  
 * 3. 贴纸尺寸计算的基准值 (calculateStickerSizeTexture)
 * 
 * 注意：修改此值会影响所有相关的坐标计算，需要确保一致性
 */
export const TEXTURE_SIZE = 4096 as const;